// import React, { useState } from "react";

// const MembershipSuggestion = ({ 
//   data, 
//   handleMembershipSuggestedClick,
//   clientMembership
// }) => {
//   const [hoveredSuggestion, setHoveredSuggestion] = useState(null);

//  const isMembershipActive = (membershipId) => {
//   const currentDate = new Date();

//   // Null or undefined check
//   if (!Array.isArray(clientMembership)) return false;

//   return clientMembership.some(membership => {
//     // Check if membership ID matches
//     if (membership.membershipId?._id !== membershipId) return false;
    
//     // Check if end date is in future
//     const endDate = new Date(membership.endDate);
//     if (endDate < currentDate) return false;
    
//     // For serviceType memberships, check if any service has count > 0
//     if (membership.membershipType === 'serviceType') {
//       return membership.services?.some(service => service.count > 0);
//     }

//     // For discountType memberships, we just check the date
//     return true;
//   });
// };


//   const handleChange = (membership, e) => {
//     if (isMembershipActive(membership._id)) {
//       // Don't proceed if membership is active
//       e.preventDefault();
//       e.stopPropagation();
//       return;
//     }
//     handleMembershipSuggestedClick(membership);
//   };

//   // Group memberships by type
//   const groupedMemberships = data.reduce((acc, membership) => {
//     const type = membership.membershipType || 'serviceType';
//     if (!acc[type]) {
//       acc[type] = [];
//     }
//     acc[type].push(membership);
//     return acc;
//   }, {});

//   const containerStyle = {
//     position: "absolute",
//     backgroundColor: "#fff",
//     border: "1px solid #ccc",
//     zIndex: 1000,
//     maxHeight: "300px",
//     overflowY: "auto",
//     boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
//     width: "300px",
//     padding: "10px",
//     borderRadius: "5px",
//   };

//   const categoryStyle = {
//     fontWeight: "bold",
//     padding: "8px 5px",
//     backgroundColor: "#f8f8f8",
//     borderBottom: "1px solid #ddd",
//     textTransform: "capitalize",
//   };

//   const itemStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     padding: "8px",
//     cursor: "pointer",
//     borderBottom: "1px solid #eee",
//     flexDirection: "column",
//   };

//   const itemContentStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     width: "100%",
//   };

//   const priceContainerStyle = {
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "flex-end",
//   };

//   const durationStyle = {
//     fontSize: "0.8em",
//     color: "#666",
//   };

//   const errorStyle = {
//     fontSize: "0.7em",
//     color: "red",
//     marginTop: "4px",
//     fontStyle: "italic",
//   };
 
//   return (
//     <div style={containerStyle}>
//       {Object.entries(groupedMemberships).map(([type, memberships]) => (
//         <div key={type}>
//           <div style={categoryStyle}>
//             {type === 'serviceType' ? 'Service Memberships' : 
//              type === 'discountType' ? 'Discount Memberships' : type}
//           </div>
//           {memberships.map((membership) => {
//             const isActive = isMembershipActive(membership._id);
//             console.log(isActive,'isActive')
//             return (
//               <div
//                 key={membership._id}
//                 onClick={(e) => handleChange(membership, e)}
//                 style={{
//                   ...itemStyle,
//                   backgroundColor: hoveredSuggestion === membership._id ? "#6174DD" : "white",
//                   color: hoveredSuggestion === membership._id ? "white" : "black",
//                   opacity: isActive ? 0.7 : 1,
//                   cursor: isActive ? "not-allowed" : "pointer",
//                 }}
//                 onMouseEnter={() => !isActive && setHoveredSuggestion(membership._id)}
//                 onMouseLeave={() => setHoveredSuggestion(null)}
//               >
//                 <div style={itemContentStyle}>
//                   <span>{membership.membershipName}</span>
//                   <div style={priceContainerStyle}>
//                     <span>₹{membership.membershipPrice}</span>
//                     {membership.duration && (
//                       <span style={{ 
//                         ...durationStyle, 
//                         color: hoveredSuggestion === membership._id ? "#eee" : "#666" 
//                       }}>
//                         {membership.duration} Month
//                       </span>
//                     )}
//                   </div>
//                 </div>
//                 {isActive && (
//                   <div style={{
//                     ...errorStyle,
//                     color: hoveredSuggestion === membership._id ? "#ffcccc" : "red"
//                   }}>
//                     This membership already exists and is active
//                   </div>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default MembershipSuggestion;

import React, { useState, useEffect, useRef } from "react";

const MembershipSuggestion = ({ 
  data, 
  handleMembershipSuggestedClick,
  clientMembership,
  inputRef,
  setMembershipSuggested,
  focusedIndex
}) => {
  const [hoveredSuggestion, setHoveredSuggestion] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const suggestionsRef = useRef(null);
  const itemRefs = useRef([]);

  // ✅ check membership active or not
  const isMembershipActive = (membershipId) => {
    const currentDate = new Date();
    if (!Array.isArray(clientMembership)) return false;

    return clientMembership.some(membership => {
      if (membership.membershipId?._id !== membershipId) return false;
      const endDate = new Date(membership.endDate);
      if (endDate < currentDate) return false;

      if (membership.membershipType === 'serviceType') {
        return membership.services?.some(service => service.count > 0);
      }
      return true;
    });
  };

  const handleChange = (membership, e) => {
    if (isMembershipActive(membership._id)) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    handleMembershipSuggestedClick(membership);
  };

  // Handle keyboard navigation
  useEffect(() => {
    const target = inputRef;
    if (!target) return;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const topMemberships = data.filter(m => m.isTopMembership);
        const otherMemberships = data.filter(m => m.membershipType === "serviceType");
        const totalItems = topMemberships.length + otherMemberships.length;
        
        setSelectedIndex(prev => (prev >= totalItems - 1 ? 0 : prev + 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const topMemberships = data.filter(m => m.isTopMembership);
        const otherMemberships = data.filter(m => m.membershipType === "serviceType");
        const totalItems = topMemberships.length + otherMemberships.length;
        
        setSelectedIndex(prev => (prev <= 0 ? totalItems - 1 : prev - 1));
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        e.preventDefault();
        
        const topMemberships = data.filter(m => m.isTopMembership);
        const otherMemberships = data.filter(m => m.membershipType === "serviceType");
        
        let selectedMembership;
        if (selectedIndex < topMemberships.length) {
          selectedMembership = topMemberships[selectedIndex];
        } else {
          selectedMembership = otherMemberships[selectedIndex - topMemberships.length];
        }
        
        if (!isMembershipActive(selectedMembership._id)) {
          handleMembershipSuggestedClick(selectedMembership);
        }
      } else if (e.key === 'Escape') {
        setMembershipSuggested([]);
        setSelectedIndex(-1);
        target.blur();
      }
    };

    target.addEventListener('keydown', handleKeyDown);
    return () => target.removeEventListener('keydown', handleKeyDown);
  }, [data, selectedIndex, inputRef, handleMembershipSuggestedClick, setMembershipSuggested]);

  // Reset index when data changes
  useEffect(() => {
    setSelectedIndex(-1);
    const topMemberships = data.filter(m => m.isTopMembership);
    const otherMemberships = data.filter(m => m.membershipType === "serviceType");
    itemRefs.current = itemRefs.current.slice(0, topMemberships.length + otherMemberships.length);
  }, [data]);

  // Scroll selected item into view
  useEffect(() => {
    if (selectedIndex >= 0 && itemRefs.current[selectedIndex]) {
      itemRefs.current[selectedIndex].scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }, [selectedIndex]);

  // ---- styles ----
  const containerStyle = {
    position: "absolute",
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    zIndex: 1000,
    maxHeight: "300px",
    overflowY: "auto",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    width: "260px",
    padding: "10px",
    borderRadius: "5px",
  };

  const categoryStyle = {
    fontWeight: "bold",
    padding: "8px 5px",
    backgroundColor: "#f8f8f8",
    borderBottom: "1px solid #ddd",
  };

  const itemStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    flexDirection: "column",
  };

  const itemContentStyle = {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  };

  const priceContainerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  };

  const durationStyle = {
    fontSize: "0.8em",
    color: "#666",
  };

  const errorStyle = {
    fontSize: "0.7em",
    color: "red",
    marginTop: "4px",
    fontStyle: "italic",
  };

  // ---- Segregate Top 5 & Other memberships ----
  const topMemberships = data.filter(m => m.isTopMembership);
  const otherMemberships = data.filter(m => m.membershipType === "serviceType");

  // Track the current index for rendering
  let currentIndex = 0;

  return (
    <div style={containerStyle} ref={suggestionsRef}>
      {topMemberships.length > 0 && (
        <div>
          <div style={categoryStyle}>Frequently Used Memberships</div>
          {topMemberships.map(membership => {
            const isActive = isMembershipActive(membership._id);
            const index = currentIndex++;
            
            return (
              <div
                key={membership._id}
                ref={el => itemRefs.current[index] = el}
                onClick={(e) => handleChange(membership, e)}
                style={{
                  ...itemStyle,
                  backgroundColor: selectedIndex === index || hoveredSuggestion === membership._id ? "#6174DD" : "white",
                  color: selectedIndex === index || hoveredSuggestion === membership._id ? "white" : "black",
                  opacity: isActive ? 0.7 : 1,
                  cursor: isActive ? "not-allowed" : "pointer",
                }}
                onMouseEnter={() => !isActive && setHoveredSuggestion(membership._id)}
                onMouseLeave={() => setHoveredSuggestion(null)}
              >
                <div style={itemContentStyle}>
                  <span>{membership.membershipName}</span>
                  <div style={priceContainerStyle}>
                    <span>₹{membership.membershipPrice}</span>
                    {membership.duration && (
                      <span
                        style={{
                          ...durationStyle,
                          color: selectedIndex === index || hoveredSuggestion === membership._id ? "#eee" : "#666",
                        }}
                      >
                        {membership.duration} Month
                      </span>
                    )}
                  </div>
                </div>
                {isActive && (
                  <div
                    style={{
                      ...errorStyle,
                      color: selectedIndex === index || hoveredSuggestion === membership._id ? "#ffcccc" : "red",
                    }}
                  >
                    This membership already exists and is active
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}

      {otherMemberships.length > 0 && (
        <div>
          <div style={categoryStyle}>Other Memberships</div>
          {otherMemberships.map(membership => {
            const isActive = isMembershipActive(membership._id);
            const index = currentIndex++;
            
            return (
              <div
                key={membership._id}
                ref={el => itemRefs.current[index] = el}
                onClick={(e) => handleChange(membership, e)}
                style={{
                  ...itemStyle,
                  backgroundColor: selectedIndex === index || hoveredSuggestion === membership._id ? "#6174DD" : "white",
                  color: selectedIndex === index || hoveredSuggestion === membership._id ? "white" : "black",
                  opacity: isActive ? 0.7 : 1,
                  cursor: isActive ? "not-allowed" : "pointer",
                }}
                onMouseEnter={() => !isActive && setHoveredSuggestion(membership._id)}
                onMouseLeave={() => setHoveredSuggestion(null)}
              >
                <div style={itemContentStyle}>
                  <span>{membership.membershipName}</span>
                  <div style={priceContainerStyle}>
                    <span>₹{membership.membershipPrice}</span>
                    {membership.duration && (
                      <span
                        style={{
                          ...durationStyle,
                          color: selectedIndex === index || hoveredSuggestion === membership._id ? "#eee" : "#666",
                        }}
                      >
                        {membership.duration} Month
                      </span>
                    )}
                  </div>
                </div>
                {isActive && (
                  <div
                    style={{
                      ...errorStyle,
                      color: selectedIndex === index || hoveredSuggestion === membership._id ? "#ffcccc" : "red",
                    }}
                  >
                    This membership already exists and is active
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MembershipSuggestion;